'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_CREST_THUMB = exports.DEFAULT_CREST_FULL = exports.DEFAULT_HERO = exports.getHeroImageUrl = exports.getThumbImageUrl = exports.getFullImageUrl = exports.HeroLoader = exports.CrestLoader = exports.DEFAULT_COLLEGE_IMAGE_ENDPOINT = undefined;

var _CrestLoader = require('./CrestLoader');

var _CrestLoader2 = _interopRequireDefault(_CrestLoader);

var _HeroLoader = require('./HeroLoader');

var _HeroLoader2 = _interopRequireDefault(_HeroLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_COLLEGE_IMAGE_ENDPOINT = exports.DEFAULT_COLLEGE_IMAGE_ENDPOINT = 'https://s3.amazonaws.com/scoir_static/assets/colleges/images';
var getCollegeImagePrefix = function getCollegeImagePrefix() {
    return window.COLLEGE_IMAGE_ENDPOINT || DEFAULT_COLLEGE_IMAGE_ENDPOINT;
};

var getFullImageUrl = function getFullImageUrl(scid) {
    return getCollegeImagePrefix() + '/full-' + scid + '-0.png';
};

var getThumbImageUrl = function getThumbImageUrl(scid) {
    return getCollegeImagePrefix() + '/thumb-' + scid + '-0.png';
};

var getHeroImageUrl = function getHeroImageUrl(scid) {
    return getCollegeImagePrefix() + '/' + scid + '-hero.png';
};

var DEFAULT_HERO = getCollegeImagePrefix() + '/college-hero.png';

var DEFAULT_CREST_FULL = getCollegeImagePrefix() + '/college-crest-full.png';

var DEFAULT_CREST_THUMB = getCollegeImagePrefix() + '/college-crest-thumb.png';

exports.CrestLoader = _CrestLoader2.default;
exports.HeroLoader = _HeroLoader2.default;
exports.getFullImageUrl = getFullImageUrl;
exports.getThumbImageUrl = getThumbImageUrl;
exports.getHeroImageUrl = getHeroImageUrl;
exports.DEFAULT_HERO = DEFAULT_HERO;
exports.DEFAULT_CREST_FULL = DEFAULT_CREST_FULL;
exports.DEFAULT_CREST_THUMB = DEFAULT_CREST_THUMB;
//# sourceMappingURL=index.js.map